// extracted by mini-css-extract-plugin
export default {"Center":"Bounties_Center__H3cLH","Bounties":"Bounties_Bounties__KqAak"};